import { jsxs as g, Fragment as H, jsx as s } from "react/jsx-runtime";
import { useState as P, useRef as K, useEffect as h } from "react";
import { useSetBodyScroll as q } from "../../hooks/useSetBodyScroll.mjs";
import { useFocusTrap as A } from "../../hooks/useFocusTrap.mjs";
import { SidePanelFooter as G } from "./SidePanelFooter.mjs";
import { SidePanelHeader as J } from "./SidePanelHeader.mjs";
/* empty css               */
import { Button as Q } from "../Button/Button.mjs";
const ie = (I) => {
  var x;
  const {
    triggerNode: c,
    heading: w,
    minimizable: z,
    className: E,
    pages: p = [],
    footer: S,
    handleCustomClose: l,
    children: B,
    openingDirection: F = "right",
    isPanelClose: N = !1,
    isOpen: v,
    stickyFooter: L = !1,
    testId: a
  } = I, i = v !== void 0, [m, f] = P(!1), [C, M] = P(!1), [d, k] = P(0), r = q(!1), y = K(null), u = !B && p.length > 1, o = i ? v : m;
  A(!!o, y, !0);
  const j = "Button Button--icon Button--icon--neutral SidePanel-Button--prev", T = "Button Button--primary u-marginLeft20 u-marginTop24 SidePanel-Button--next" + (d === p.length - 1 ? " u-hidden" : ""), b = (e) => {
    r(!1), i || f(!1), l && l(), e && (e.preventDefault(), e.stopPropagation());
  };
  h(() => {
    !i && N && m && b();
  }, [N, i, m]), h(() => {
    r(!!o);
  }, [o]), h(() => {
    const e = (t) => {
      t.key === "Escape" && o && (i || f(!1), r(!1), l && l());
    };
    return document.addEventListener("keydown", e, !1), () => {
      document.removeEventListener("keydown", e, !1);
    };
  }, [l, o, i, r]);
  const V = (e) => {
    f(!0), r(!0), e.stopPropagation();
  }, D = (e) => {
    M((t) => {
      const n = !t;
      return r(!n), n;
    }), e.stopPropagation();
  }, O = (e) => {
    e.stopPropagation(), k(d + 1);
  }, R = (e) => {
    e.stopPropagation(), k(d - 1);
  }, W = (e = []) => e.map((t, n) => {
    const $ = "SidePanel-section" + (e.length > 1 && n < e.length - 1 ? " SidePanel-section--withBorder" : "");
    return /* @__PURE__ */ s("section", { className: $, children: t }, n);
  });
  return /* @__PURE__ */ g(H, { children: [
    !i && c && !o && /* @__PURE__ */ s(
      Q,
      {
        ...c.props,
        onClick: (e) => {
          var t, n;
          V(e), (n = (t = c.props).onClick) == null || n.call(t, e);
        },
        testId: a ? `${a}-trigger-button` : void 0,
        children: c.props.children
      }
    ),
    /* @__PURE__ */ s(
      "aside",
      {
        ref: y,
        tabIndex: -1,
        className: [
          "SidePanel",
          E || "",
          o ? "is-visible" : "",
          C ? "is-minimized" : "",
          F === "left" ? "SidePanel--left" : "",
          L && S ? "SidePanel--sticky-footer" : ""
        ].filter(Boolean).join(" "),
        "data-testid": a || void 0,
        children: /* @__PURE__ */ g("section", { className: "SidePanel-main", children: [
          /* @__PURE__ */ g("div", { className: "SidePanel-topWrapper", children: [
            /* @__PURE__ */ s(
              J,
              {
                prevBtnClassNames: j,
                handlePrevPageBtn: R,
                heading: w,
                minimizable: z,
                isMinimized: C,
                toggleMinimized: D,
                handleClose: b,
                showPrevButton: u,
                isOnPrevPage: u && d > 0,
                testId: a ? `${a}-header` : void 0
              }
            ),
            /* @__PURE__ */ s("div", { className: "SidePanel-sectionsWrapper", children: B || W((x = p[d]) == null ? void 0 : x.sections) }),
            u && /* @__PURE__ */ s(
              "button",
              {
                className: T,
                title: "Next page in panel",
                onClick: O,
                children: "Next Page"
              }
            )
          ] }),
          /* @__PURE__ */ s(G, { footer: S })
        ] })
      }
    )
  ] });
};
export {
  ie as SidePanelContainer
};
//# sourceMappingURL=SidePanelContainer.mjs.map
